import React from 'react';
import { Layout } from '../components/common';
import { ProductsHeroSection } from '../components/products';

const ProductsPage: React.FC = () => {
  return (
    <Layout>
      <ProductsHeroSection />
    </Layout>
  );
};

export default ProductsPage;